import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";

import CustomerSelect from "../../common/CustomerSelect";
import UserSelect from "../../common/UserSelect";
import ProjectSelect from "../../common/ProjectSelect";
import CallTypeSelect from "../../common/CallTypeSelect";
import DepartmentSelect from "../../common/DepartmentSelect";
import ProjectCategorySelect from "../../common/ProjectCategorySelect";
import ProjectStatusSelect from "../../common/ProjectStatusSelect";

import ReportFilters from "../ReportFiltersComponent";

const ProjectProgressFilters = ({
  onFetchClick,
  onChange,
  onResetClick,
  loading,
  disabled,
  exportDisabled,
  onCSVExport,
  filters
}) => (
  <ReportFilters
    onFetchClick={onFetchClick}
    onResetClick={onResetClick}
    title="Project Progress"
    loading={loading}
    disabled={disabled}
    csvExportAvailable
    exportDisabled={exportDisabled}
    onCSVExport={onCSVExport}
  >
    <Row>
      <Col md={3}>
        <CustomerSelect
          placeholder="Select"
          label="Customer *"
          isMulti
          onChange={onChange("customers")}
          value={filters.customers || []}
        />
      </Col>
      <Col md={3}>
        <ProjectSelect
          placeholder="Select"
          label="Project"
          isMulti
          onChange={onChange("projects")}
          value={filters.projects || []}
        />
      </Col>
      <Col md={3}>
        <CallTypeSelect
          label="Call Type"
          isMulti
          onChange={onChange("callTypes")}
          value={filters.callTypes || []}
        />
      </Col>
      <Col md={3}>
        <ProjectCategorySelect
          placeholder="Select"
          label="Category"
          isMulti
          onChange={onChange("categories")}
          value={filters.categories || []}
        />
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <DepartmentSelect
          placeholder="Select"
          label="Department"
          isMulti
          onChange={onChange("departments")}
          value={filters.departments || []}
        />
      </Col>
      <Col md={3}>
        <ProjectStatusSelect
          placeholder="Select"
          label="Project Status"
          isMulti
          onChange={onChange("statuses")}
          value={filters.statuses || []}
        />
      </Col>
      <Col md={3}>
        <UserSelect
          label="Project Manager"
          isMulti
          placeholder="Select"
          onChange={onChange("managers")}
          value={filters.managers || []}
        />
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          * Required Fields
        </label>
      </Col>
    </Row>
  </ReportFilters>
);

ProjectProgressFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  onFetchClick: PropTypes.func,
  onResetClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  exportDisabled: PropTypes.bool,
  onCSVExport: PropTypes.func,
  filters: PropTypes.object
};
export default ProjectProgressFilters;
